import { ApolloClient } from "@apollo/client/core";
import { gql } from "graphql-tag";

import { UserBookSerializersUserBookDate } from "types/serializers";

// UPDATE
const updateUserBookReadMutation = gql`
  mutation UpdateUserBookReadMutation($id: Int!, $object: DatesReadInput!) {
    updateResult: update_user_book_read(id: $id, object: $object) {
      error
      userBookRead: user_book_read {
        ...UserBookReadFragment
      }
    }
  }
`;

export async function updateUserBookRead({
  client,
  id,
  object,
}: {
  client: ApolloClient<any>;
  id: number;
  object: UserBookSerializersUserBookDate;
}): Promise<UserBookSerializersUserBookDate> {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: updateUserBookReadMutation,
        variables: {
          id,
          object: {
            started_at: object.startedAt,
            finished_at: object.finishedAt,
            edition_id: object.editionId,
            progress_pages: object.progressPages,
            progress_seconds: object.progressSeconds,
          },
        },
      })
      .then(result => {
        if (result.data.updateResult.error) {
          reject(result.data.updateResult.error);
        } else {
          resolve(result.data.updateResult.userBookRead);
        }
      })
      .catch(e => {
        reject(e.message);
      });
  });
}
